import { firebaseConnect } from 'react-redux-firebase'
import WishForm from './WishForm';

export default firebaseConnect([])(WishForm);



// WEBPACK FOOTER //
// ./src/components/WishForm/index.js